define.alias("shared/components/shared/mobile/drawer/feature-drawer", "settings/components/shared/mobile/drawer/feature-drawer");